import React from "react";

function DetailPageSkeleton() {
  return (
    <div className="px-5 mt-6 min-w-full animate-pulse">
      {/* Header */}
      <div className="flex w-full">
        <div className="w-1/12">
          <div className="w-8 h-8 bg-gray-200 rounded"></div>
        </div>
        <div className="w-10/12 flex justify-center">
          <div className="h-6 bg-gray-200 rounded w-1/2"></div>
        </div>
        <div className="w-1/12 flex justify-end">
          <div className="w-6 h-6 bg-gray-200 rounded"></div>
        </div>
      </div>

      {/* Reward Text */}
      <div className="flex flex-col text-xs items-center pt-3">
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
      </div>

      {/* Important Date */}
      <div className="flex flex-col gap-3 mt-6">
        <div className="p-5 bg-gray-100 rounded-md flex flex-col gap-2">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="flex items-center">
              <div className="w-3/12">
                <div className="h-4 bg-gray-200 rounded w-2/3"></div>
              </div>
              <div className="w-9/12">
                <div className="h-4 bg-gray-200 rounded w-full"></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Images */}
      <div className="overflow-x-auto flex h-[180px] gap-2 w-full mt-4">
        <div className="flex gap-2">
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className="w-40 h-40 bg-gray-200 rounded-xl flex-shrink-0"
            ></div>
          ))}
        </div>
      </div>

      {/* Information Sections */}
      {[...Array(4)].map((_, i) => (
        <div key={i} className="flex flex-col gap-3 mt-7 border-b pb-7">
          <div className="h-5 bg-gray-200 rounded w-24"></div>
          <div className="flex flex-col gap-2">
            <div className="h-4 bg-gray-200 rounded w-full"></div>
            <div className="h-4 bg-gray-200 rounded w-5/6"></div>
            <div className="h-4 bg-gray-200 rounded w-4/6"></div>
          </div>
        </div>
      ))}

      {/* Keywords */}
      <div className="flex gap-2 flex-wrap mt-4">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="h-8 bg-gray-200 rounded-full w-20"></div>
        ))}
      </div>

      {/* Map */}
      <div className="mt-7 border-b pb-7">
        <div className="flex gap-2 mb-2">
          <div className="h-5 bg-gray-200 rounded w-20"></div>
          <div className="h-5 bg-gray-200 rounded w-24"></div>
        </div>
        <div className="w-full h-[150px] bg-gray-200 rounded"></div>
      </div>

      {/* Guidelines */}
      <div className="flex flex-col gap-3 mt-7 border-b pb-7">
        <div className="h-5 bg-gray-200 rounded w-24"></div>
        <div className="flex gap-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 bg-gray-200 rounded"></div>
              <div className="h-3 bg-gray-200 rounded w-16"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Apply Button */}
      <div className="flex flex-col gap-3 mt-9">
        <div className="h-12 bg-gray-200 rounded-full w-full"></div>
      </div>
    </div>
  );
}

export default DetailPageSkeleton;
